import { render, staticRenderFns } from "./passengerConfirm.vue?vue&type=template&id=5a9803b5&"
import script from "./passengerConfirm.vue?vue&type=script&lang=ts&"
export * from "./passengerConfirm.vue?vue&type=script&lang=ts&"
import style0 from "./passengerConfirm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports